import React from 'react';
import PropTypes from 'prop-types';

const Social = ({ social, onClick }) => {

  return (
    <div className={"social"} onClick={onClick}>
      <img src={`${process.env.PUBLIC_URL}/assets/images/socials/${social}.svg`} alt={social} />
    </div>
  );

};

Social.propTypes = {
  social: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Social;
